import "@finn-no/favorite-heart-component/dist/style.css";
import ReactDOM from "react-dom/client";
import "virtual:uno.css";
import { App, type AppProps } from "./App.tsx";
import { dynamicActivate } from "./i18n.ts";
import "./styles.css";
import { addTrackJSMetadata } from "./utils/trackjs.ts";

const root = document.querySelector("#mobility-item-page-root");

async function hydrate() {
  const encodedProps = root?.getAttribute("data-props");
  const props: AppProps | undefined = encodedProps ? JSON.parse(decodeURIComponent(atob(encodedProps))) : undefined;

  if (encodedProps && root) {
    root.removeAttribute("data-props");
  }

  if (!root || !props || Object.keys(props).length === 0) {
    return;
  }
  const { appConfig } = props;

  await dynamicActivate(appConfig.locale);
  addTrackJSMetadata(appConfig);

  ReactDOM.hydrateRoot(root, <App {...props} />);
}

hydrate();
